import { render, staticRenderFns } from "./PaidActionConfirm.vue?vue&type=template&id=15dd22de&scoped=true&lang=pug&"
import script from "./PaidActionConfirm.vue?vue&type=script&lang=ts&"
export * from "./PaidActionConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PaidActionConfirm.vue?vue&type=style&index=0&id=15dd22de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd22de",
  null
  
)

export default component.exports